import {
  MARK_NOTIFICATION_READ,
  MARK_ALL_NOTIFICATIONS_READ,
  DELETE_NOTIFICATION,
  DELETE_ALL_NOTIFICATIONS,
  FETCH_NOTIFICATIONS_SUCCESS,
  NOTIFICATIONS_REQUEST,
  NOTIFICATIONS_FAILURE,
  ADD_NOTIFICATION,
  SET_NOTIFICATION_COUNTS,
} from "./types";
import axiosInstance from "../../services/api";

const normalizeNotificationsResponse = (response) => {
  const payload = Array.isArray(response?.data?.data)
    ? response.data
    : response;

  if (Array.isArray(payload)) {
    return {
      notificationsList: payload,
      total: undefined,
      unreadCount: undefined,
      unreadCountsByTab: undefined,
    };
  }

  return {
    notificationsList: Array.isArray(payload?.data) ? payload.data : [],
    total: payload?.total,
    unreadCount: payload?.unreadCount,
    unreadCountsByTab: payload?.unreadCountsByTab,
  };
};

// Fetch notifications from the backend with pagination support
export const fetchNotifications =
  (page = 1, limit = 10, append = false, filters = {}) =>
  async (dispatch, getState) => {
    dispatch({ type: NOTIFICATIONS_REQUEST });
    try {
      const params = new URLSearchParams({
        page: String(page),
        limit: String(limit),
      });

      if (filters?.tab && filters.tab !== "all") {
        params.set("tab", filters.tab);
      }
      if (filters?.category) {
        params.set("category", filters.category);
      }
      if (filters?.type) {
        params.set("type", filters.type);
      }

      const response = await axiosInstance.get(
        `notifications/my-notifications?${params.toString()}`,
      );
      const { notificationsList, total, unreadCount, unreadCountsByTab } =
        normalizeNotificationsResponse(response);
      const currentUserId = getState()?.auth?.user?.id;
      dispatch({
        type: FETCH_NOTIFICATIONS_SUCCESS,
        payload: notificationsList,
        meta: {
          currentUserId,
          append,
          page,
          limit,
          total,
          unreadCount,
          unreadCountsByTab,
          filters,
        },
      });
      return {
        data: notificationsList,
        total,
        unreadCount,
        unreadCountsByTab,
        page,
        limit,
      };
    } catch (error) {
      dispatch({
        type: NOTIFICATIONS_FAILURE,
        payload: error.message,
      });
      return {
        data: [],
        total: 0,
        unreadCount: 0,
        unreadCountsByTab: undefined,
        page,
        limit,
      };
    }
  };

// Add a real-time incoming notification from WebSocket
export const addNotification = (notification, currentUserId) => ({
  type: ADD_NOTIFICATION,
  payload: notification,
  meta: { currentUserId },
});

export const setNotificationCounts = (counts = {}) => ({
  type: SET_NOTIFICATION_COUNTS,
  payload: counts,
});

// Mark single notification as read in the DB and local state
export const markNotificationRead = (id) => async (dispatch) => {
  try {
    await axiosInstance.put(`notifications/${id}/read`);
    dispatch({
      type: MARK_NOTIFICATION_READ,
      payload: id,
    });
  } catch (error) {
    console.error("❌ Failed to mark notification as read:", error.message);
  }
};

// Mark all notifications as read in the DB and local state
export const markAllNotificationsRead = () => async (dispatch) => {
  try {
    await axiosInstance.put("notifications/read-all");
    dispatch({
      type: MARK_ALL_NOTIFICATIONS_READ,
    });
  } catch (error) {
    console.error(
      "❌ Failed to mark all notifications as read:",
      error.message,
    );
  }
};

// Delete notification (pull from user list) in DB and local state
export const deleteNotification = (id) => async (dispatch) => {
  try {
    await axiosInstance.delete(`notifications/${id}`);
    dispatch({
      type: DELETE_NOTIFICATION,
      payload: id,
    });
  } catch (error) {
    console.error("❌ Failed to delete notification:", error.message);
  }
};

export const deleteAllNotifications = () => ({
  type: DELETE_ALL_NOTIFICATIONS,
});
